<template xmlns="http://www.w3.org/1999/html">
    <div v-if="isLoading">
        <span class="fa fa-spinner fa-spin"></span>
    </div>
    <div v-else>
        <b-row>
            <b-col>
                <div class="accordion">
                    <!-- SCAN PRODUCT -->
                    <b-card class="mb-1" no-body ref="product-scan" :class="{'opacity-8': scannedLine}">
                        <b-card-header class="text-left py-2 pl-3">
                            <b-card-title class="m-0 d-block w-100">
                                <b-row v-if="!scannedLine">
                                    <b-col cols="6">SCAN ARTIKEL</b-col>
                                    <b-col cols="6" class="text-right pr-2 pr-md-4">
                                        <a v-if="!isUnableToShipMode && hasPermission('orders.batch.process.sort.mancos') && isUnableToShipPossible" href="#" class="text-danger font-weight-normal" @click.prevent="isUnableToShipMode = true">
                                            <small>Kan niet leveren</small>
                                        </a>
                                    </b-col>
                                </b-row>
                                <div v-else>
                                    GESCAND:<br />
                                    <span class="font-weight-normal d-inline-block mt-2">
                                        <product-scanned-info :dispatch-request-line="scannedLine"/>
                                    </span>
                                    <small v-if="scannedLineSalesOrderIdentifier" class="font-weight-normal d-inline-block mt-2 ml-2 text-black-50">
                                        (order: <b-link :to="{name: 'OrderDetailOverview', params: {salesOrderIdentifier: scannedLineSalesOrderIdentifier }}" class="text-black-50" target="_blank">{{ scannedLineSalesOrderIdentifier }}</b-link>)
                                    </small>
                                </div>
                            </b-card-title>
                        </b-card-header>
                        <b-collapse id="accordion-product-scan" visible accordion="orderpicking-steps">
                            <div class="accordion">
                                <b-card-body class="p-3">
                                    <b-collapse id="accordion-product-scan-main" visible accordion="product-scan-accordion">
                                        <div v-if="unableToShipMessage" class="mb-3">
                                            <small>
                                                <font-awesome-icon icon="check-circle" class="text-success mr-1"/>
                                                {{ unableToShipMessage }}
                                            </small>
                                        </div>

                                        <b-alert :show="isProductScanSuggestionEnabled" variant="info">
                                            <b-row v-if="suggestedScanLine" class="mb-1">
                                                <b-col cols="8">
                                                    <font-awesome-icon icon="lightbulb" class="text-warning mr-2"/>
                                                    <small><i>{{ $t('product-processing.pick-suggestion.title') }}</i></small>
                                                </b-col>
                                                <b-col cols="4" class="text-right">
                                                    <small class="text-info" v-b-tooltip.click="$t('product-processing.pick-suggestion.tooltip-main')">
                                                        <font-awesome-icon icon="question-circle"/>
                                                    </small>
                                                </b-col>
                                            </b-row>

                                            <font-awesome-icon v-if="isLoadingSuggestedScanLines" icon="spinner" spin/>
                                            <span v-else-if="isSuggestedScanLinesError" class="text-danger">
                                                {{ $t('product-processing.pick-suggestion.error') }}
                                            </span>
                                            <show-suggested-scan-line v-else-if="suggestedScanLine" :suggested-scan-line="suggestedScanLine" :data-eans="suggestedScanLine.ean_codes?.join('|')"/>
                                            <span v-else class="text-primary" v-html="$t('product-processing.pick-suggestion.no-suggestion-found')"/>
                                        </b-alert>

                                        <b-alert :show="!!(isShowPreviousScannedLineEnabled && showPreviousScannedLineTimer && previousScannedLine)" variant="light" class="py-1 px-2">
                                            <span class="loader">{{showPreviousScannedLineTimer}}</span>
                                            <small class="d-block float-left w-75">
                                                <strong>VORIG GESCANDE ARTIKEL:</strong>
                                                <product-scanned-info :dispatch-request-line="previousScannedLine"/>
                                            </small>
                                            <div style="clear:both;"/>
                                        </b-alert>

                                        <product-scan-sort @success="finishScanProduct" :key="`${currentStep}_${scanCycle}`"
                                                           :storage-zone-identifier="storageZoneIdentifier"
                                                           :location="location"
                                                           :batch-model-type="batchModelType"
                                                           :batch-model-identifier="batchModelIdentifier"
                                                           :process-type="processType"
                                        />
                                    </b-collapse>
                                    <b-collapse id="accordion-product-scan-unable-to-ship" accordion="product-scan-accordion">
                                            <unable-to-ship v-if="isUnableToShipMode" :key="`uts_${currentStep}_${scanCycle}`"
                                                            :storage-zone-identifier="storageZoneIdentifier"
                                                            :batch-model-type="batchModelType"
                                                            :batch-model-identifier="batchModelIdentifier"
                                                            :location="location"
                                                            :process-type="processType"
                                                            :suggested-lines="suggestedScanLines"
                                                            @close="closeUnableToShipView"
                                            />
                                    </b-collapse>
                                </b-card-body>
                            </div>
                        </b-collapse>
                    </b-card>

                    <!-- SPECIAL -->
                    <b-card class="mb-1" no-body :class="{inactive: !isStepActive('special-processing')}" ref="special-processing">
                        <b-card-header class="text-left py-2 pl-3">
                            <b-card-title class="m-0">
                                SPECIALE VERWERKING
                                <span v-if="isStepActive('special-processing') && countSpecialProcessingSteps > 1">
                                    ({{countSpecialProcessingSteps - specialProcessingIdentifiers.length}}/{{countSpecialProcessingSteps}})
                                </span>
                            </b-card-title>
                        </b-card-header>
                        <b-collapse id="accordion-special-processing" accordion="orderpicking-steps">
                            <b-card-body class="p-3">
                                <b-collapse id="special-process-container" :key="scanCycle" visible :appear="countSpecialProcessingSteps - specialProcessingIdentifiers.length !== 1">
                                    <component v-for="specialProcess in SPECIAL_PROCESSES" :key="specialProcess.methods.getIdentifier() + scanCycle"
                                               v-show="specialProcess.methods.getIdentifier() === currentSpecialProcess"
                                               v-bind:is="specialProcess"
                                               @success="(metadata) => finishSpecialProcessingStep(specialProcess.methods.getIdentifier(), true, metadata)"
                                               @fail="finishSpecialProcessingStep(specialProcess.methods.getIdentifier(), false)"
                                               :batch-model-type="batchModelType"
                                               :dispatch-request="dispatchRequest"
                                               :scanned-line="scannedLine"
                                               :product-identifier="productIdentifier"
                                               :location="location"
                                               :has-location-auto-create-on-goods-receipt-line-enabled="hasLocationAutoCreateOnGoodsReceiptLineEnabled"
                                               :ref="specialProcess.methods.getIdentifier()"
                                    />
                                </b-collapse>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <!-- SORTING LOCATION -->
                    <b-card class="mb-1" no-body :class="{inactive: !isStepActive('sorting-location-scan')}" ref="sorting-location-scan">
                        <b-card-header class="text-left py-2 pl-3">
                            <b-card-title class="m-0">SCAN LEGPLAATS</b-card-title>
                        </b-card-header>
                        <b-collapse id="accordion-sorting-location-scan" accordion="orderpicking-steps">
                            <b-card-body class="p-3">
                                <sorting-location-scan v-if="sortingLocation && isStepActive('sorting-location-scan')" @success="finishSortingLocationScan" :key="currentStep"
                                                       :storage-zone-identifier="storageZoneIdentifier"
                                                       :location="location"
                                                       :batch-model-type="batchModelType"
                                                       :batch-model-identifier="batchModelIdentifier"
                                                       :process-type="processType"

                                                       :storage-location-identifier="sortingLocation.identifier"
                                                       :storage-location-display-name="sortingLocation.display_name"
                                                       :product-identifier="productIdentifier"
                                                       :quantity="quantity"
                                                       :dispatch-request="dispatchRequest"

                                                       :special-processing-steps-result="specialProcessingIdentifiersCompleted"
                               />
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <!-- ORDER COMPLETION -->
                    <b-card class="mb-1" no-body :class="{inactive: !isStepActive('order-completion')}" ref="order-completion">
                        <b-card-header class="text-left py-2 pl-3">
                            <b-card-title class="m-0">
                                ORDER COMPLEET
                                <span v-if="isStepActive('order-completion') && countOrderCompletionSteps > 1">
                                    ({{countOrderCompletionSteps - orderCompletionProcessIdentifiers.length}}/{{countOrderCompletionSteps}})
                                </span>
                            </b-card-title>
                        </b-card-header>
                        <b-collapse id="accordion-order-completion" accordion="orderpicking-steps">
                            <b-card-body class="p-3">
                                <b-collapse id="order-completion-container" :key="currentOrderCompletionProcess?.name" visible :appear="countOrderCompletionSteps - orderCompletionProcessIdentifiers.length !== 1">
                                    <component v-for="orderCompletionProcess in ORDER_COMPLETION_PROCESSES" :key="orderCompletionProcess.methods.getIdentifier() + scanCycle"
                                               v-show="orderCompletionProcess.methods.getIdentifier() === currentOrderCompletionProcess"
                                               v-bind:is="orderCompletionProcess"
                                               @success="(newDrqData) => finishOrderCompletionStep(newDrqData ?? {})"
                                               @fail="nextStep"
                                               :batch-model-type="batchModelType"
                                               :dispatch-request="dispatchRequest"
                                               :ref="orderCompletionProcess.methods.getIdentifier()"
                                    />
                                </b-collapse>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from "lodash"
import PageTitle from "../../components/PageTitle.vue";
import ProductScanSort from "./Steps/ProductScanSort.vue";
import SortingLocationScan from "./Steps/SortingLocationScan.vue";
import SpecialProcessProductNotInRequestedDrq from "./Steps/SpecialProcessProductNotInRequestedDrq.vue";
import SpecialProcessProvideExtraProductInfo from "./Steps/SpecialProcessProvideExtraProductInfo.vue";
import OrderCompletionMarkSortingLocationAsComplete from "./Steps/OrderCompletionMarkSortingLocationAsComplete.vue";
import SpecialProcessPrintPackingSlip from "./Steps/SpecialProcessPrintPackingSlip.vue";
import OrderCompletionScanLabel from "./Steps/OrderCompletionScanLabel.vue";
import OrderCompletionMarkDispatchRequestAsShipped from "./Steps/OrderCompletionMarkDispatchRequestAsShipped.vue";
import SpecialProcessMultipleQuantities from "./Steps/SpecialProcessMultipleQuantities.vue";
import {getLocationPropertyValue} from "@/helpers/locations";
import {UsesProductProcessApi} from "@/views/ProductProcessing/Steps/UsesProductProcessApi";
import ProductScannedInfo from "@/views/ProductProcessing/Components/ProductScannedInfo.vue";
import ShowSuggestedScanLine from "@/views/ProductProcessing/Components/ShowSuggestedScanLine.vue";
import UnableToShip from "@/views/ProductProcessing/Components/UnableToShip.vue";
import ProductNumber from "@/components/ProductNumber.vue";

export const ORDER_COMPLETION_PROCESSES = {
    MARK_SORTING_LOCATION_AS_READY: 'mark_sorting_location_as_ready',
}

export default {
    extends: UsesProductProcessApi,
    name: "ProcessSort",
    components: {
        ProductNumber,
        UnableToShip,
        ShowSuggestedScanLine,
        ProductScannedInfo,
        OrderCompletionMarkSortingLocationAsComplete, SpecialProcessProvideExtraProductInfo, SpecialProcessProductNotInRequestedDrq, SortingLocationScan, ProductScanSort, PageTitle},

    props: {
        location: {required: true, type: Object},
        batchModelType: {required: true, type: String},
        batchModelIdentifier: {required: true, type: String},
        storageZoneIdentifier: {required: true, type: String},
        processType: {required: true, type: String},
    },

    data() {
        return {
            isLoading: false,
            isLoadingSuggestedScanLines: false,
            isSuggestedScanLinesError: false,
            isUnableToShipMode: false,
            unableToShipMessage: undefined,
            scanCycle: 0,
            currentStep: '',
            productIdentifier: '',
            quantity: 1,
            dispatchRequest: null,
            scannedLine: null,
            previousScannedLine: true,
            suggestedScanLines: [],
            isLastScan: null,
            specialProcessingIdentifiers: [],
            specialProcessingIdentifiersCompleted: {},
            currentSpecialProcess: '',
            countSpecialProcessingSteps: 0,
            sortingLocation: null,
            finishedSortingLocationStep: false,
            orderCompletionProcessIdentifiers: [],
            currentOrderCompletionProcess: '',
            countOrderCompletionSteps: 0,
            showPreviousScannedLineTimer: 0,
        }
    },

    computed: {
        SPECIAL_PROCESSES() {
            // Also defines order of execution
            // Vergeet deze niet ook toe te voegen aan de Frontend Parameters! (Zie: \App\Structs\Omt\Settings\FrontendParametersProcessProductsSort)
            let processes = [
                SpecialProcessProvideExtraProductInfo,
                SpecialProcessMultipleQuantities,
                SpecialProcessPrintPackingSlip,
                SpecialProcessProductNotInRequestedDrq,
            ]

            return processes.filter(process => this.$store.getters.getFrontendParameterValue('process-products-sort', 'special-processing-steps-enabled').includes(process.methods.getIdentifier()))
        },
        ORDER_COMPLETION_PROCESSES() {
            // Also defines order of execution
            // Vergeet deze niet ook toe te voegen aan de Frontend Parameters! (Zie: \App\Structs\Omt\Settings\FrontendParametersProcessProductsSort)
            let processes = [
                OrderCompletionScanLabel,
                OrderCompletionMarkSortingLocationAsComplete,
                OrderCompletionMarkDispatchRequestAsShipped,
            ]
            return processes.filter(process => this.$store.getters.getFrontendParameterValue('process-products-sort', 'extra-completion-steps-enabled')?.includes(process.methods.getIdentifier()))
        },
        scannedLineSalesOrderIdentifier() {
            return this.scannedLine.sales_order_line?.sales_order?.identifier
                ?? this.dispatchRequest?.sales_order?.identifier
        },
        isScanningGoodsReceipt() {
            return this.batchModelType === 'goods-receipt'
        },
        hasLocationAutoCreateOnGoodsReceiptLineEnabled() {
            return this.isScanningGoodsReceipt && getLocationPropertyValue(this.location.location_properties, 'goodsReceiptImportOnScan')
        },
        isShowPreviousScannedLineEnabled() {
            return !!getLocationPropertyValue(this.location.location_properties, 'processProduct.showPreviousScannedProduct')
        },
        isProductScanSuggestionEnabled() {
            return !!getLocationPropertyValue(this.location.location_properties, 'processProducts.productScanSuggestion.enabled')
        },
        suggestedScanLine() {
            return this.suggestedScanLines[0] ?? null
        },
        isUnableToShipPossible() {
            if (!this.isProductScanSuggestionEnabled) {
                return true
            }

            return !!this.suggestedScanLine
        }
    },

    mounted() {
        this.setCurrentProductQuantity(null)
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            if (collapseId.toString().startsWith('accordion-') && isJustShown) {
                this.currentStep = collapseId
            }
        })

        this.getProductScanSuggestion()
    },

    beforeDestroy() {
        this.$root.$off("bv::collapse::state");
    },

    methods: {
        getPageTitle() {
            return 'Orders Sorteren'
        },
        nextStep() {
            if (this.specialProcessingIdentifiers && this.specialProcessingIdentifiers.length) {
                this.currentSpecialProcess = Array.shift(this.specialProcessingIdentifiers)
                this.$refs[this.currentSpecialProcess][0].onShow()
                this.setActiveStep('special-processing')
            }
            else if (!this.dispatchRequest) {
                // Als je een GoodsReceiptLine aan het scannen bent ZONDER gekoppeld DRQ moet hier de quantity_scanned worden geüpdatet
                if (this.isScanningGoodsReceipt) {
                    this.saveGoodsReceiptLineQuantityScanned()
                }
                this.resetSteps()
            }
            else if (!this.finishedSortingLocationStep && this.sortingLocation) {
                this.setActiveStep('sorting-location-scan')
            }
            else if (this.orderCompletionProcessIdentifiers && this.orderCompletionProcessIdentifiers.length) {
                this.currentOrderCompletionProcess = Array.shift(this.orderCompletionProcessIdentifiers)
                this.setActiveStep('order-completion')
            }
            else {
                this.resetSteps()
            }
        },
        resetSteps() {
            this.scanCycle++
            this.previousScannedLine = structuredClone(this.scannedLine)
            this.showPreviousScannedLineTimer = 9
            this.productIdentifier = ''
            this.isLastScan = null
            this.dispatchRequest = null
            this.scannedLine = null
            this.finishedSortingLocationStep = false
            this.currentSpecialProcess = null
            this.currentOrderCompletionProcess = null
            this.isUnableToShipMode = false
            this.unableToShipMessage = undefined
            this.setCurrentProductQuantity(null)
            this.getProductScanSuggestion()
            this.setActiveStep('product-scan')

            const interval = setInterval(
                () => {
                    this.showPreviousScannedLineTimer--;
                    if (!this.showPreviousScannedLineTimer) {
                        clearInterval(interval)
                    }
                },
                1000
            )
        },
        setActiveStep(step) {
            if (this.isStepActive(step)) {
                return
            }

            this.$root.$emit('bv::toggle::collapse', `accordion-${step}`)
            this.$smoothScroll({
                scrollTo: this.$refs[step],
                updateHistory: false,
                offset: -140, // FIXME: calculate dynamically
            })
        },
        isStepActive(step) {
            return this.currentStep === `accordion-${step}`
        },
        getProductScanSuggestion() {
            if (!this.isProductScanSuggestionEnabled) {
                return
            }

            this.suggestedScanLines = []
            this.isSuggestedScanLinesError = false
            this.isLoadingSuggestedScanLines = true

            this.$http.get(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/storage-locations/${this.storageZoneIdentifier}/process-product/${this.processType}/suggest-scan-product`, {
                params: this.postData
            })
                .then(response => {
                    this.suggestedScanLines = response.data
                })
                .catch(e => {
                    console.error(e)
                    this.isSuggestedScanLinesError = true
                })
                .finally(() => this.isLoadingSuggestedScanLines = false)
        },
        finishScanProduct(productIdentifier, dispatchRequest, scannedLine, sortingLocation, isLastScan) {
            this.productIdentifier = productIdentifier
            this.dispatchRequest = dispatchRequest
            this.previousScannedLine = null
            this.scannedLine = scannedLine
            this.isLastScan = isLastScan
            this.quantity = 1
            if (!sortingLocation) {
                sortingLocation = {
                    identifier: '',
                    display_name: '',
                }
            }

            if (!sortingLocation.display_name) {
                sortingLocation.display_name = sortingLocation.identifier
            }

            this.sortingLocation = sortingLocation

            this.checkStepsNeeded(this.SPECIAL_PROCESSES)
                .then(specialProcessingStepsNeeded => {
                    this.specialProcessingIdentifiers = specialProcessingStepsNeeded
                    this.countSpecialProcessingSteps = this.specialProcessingIdentifiers.length
                    this.nextStep()
                })
        },
        finishSpecialProcessingStep(step, success, metadata) {
            if (success) {
                this.specialProcessingIdentifiersCompleted[step] = metadata
            }

            if ([SpecialProcessMultipleQuantities.methods.getIdentifier(), SpecialProcessProvideExtraProductInfo.methods.getIdentifier()].includes(step)) {
                this.quantity = metadata?.quantity || 1
            }

            this.nextStep()
        },
        finishSortingLocationScan({is_last_scan}) {
            this.isLastScan = is_last_scan
            this.finishedSortingLocationStep = true

            if (!this.isLastScan) {
                return this.nextStep()
            }

            this.checkStepsNeeded(this.ORDER_COMPLETION_PROCESSES)
                .then(orderCompletionProcessNeeded => {
                    this.orderCompletionProcessIdentifiers = orderCompletionProcessNeeded
                    this.countOrderCompletionSteps = this.orderCompletionProcessIdentifiers.length
                    this.nextStep()
                })
        },
        finishOrderCompletionStep(newDispatchRequestData = {}) {
            this.dispatchRequest = {
                ...this.dispatchRequest,
                newDispatchRequestData,
            }
            this.nextStep()
        },
        async checkStepsNeeded(allSteps) {
            const stepsNeeded = []
            const promises    = []

            const allStepIdentifers = allSteps.map(step => step.methods.getIdentifier())

            _.each(allStepIdentifers, stepIdentifier => {
                // Each SpecialProcessingComponent must include a `isRequired()` function that must return a Promise with true/false whether the step needs to executed
                // The other required function is `getIdentifier()`
                promises.push(
                    this.$refs[stepIdentifier][0].isRequired(this.batchModelType, this.productIdentifier, this.dispatchRequest, this.sortingLocation, this.isLastScan, this.scannedLine)
                        .then(shouldDo => {
                            if (shouldDo) {
                                // Add the step to the to-be processed steps
                                stepsNeeded.push(stepIdentifier)
                            }
                        })
                        .catch(e => {
                            // Only log, don't crash
                            console.error([new Error(`Error checking step '${stepIdentifier}'`), { originalError: e }])
                        })
                )
            })

            // Only proceed when all checks are complete
            return Promise.all(promises)
                .then(() => _.orderBy(stepsNeeded, step => allStepIdentifers.indexOf(step)))
        },
        setCurrentProductQuantity(quantity) {
            localStorage.setItem('processProduct.sort.currentProductQuantity', quantity)
        },
        getCurrentProductQuantity() {
            return JSON.parse(localStorage.getItem('processProduct.sort.currentProductQuantity') ?? 'null')
        },
        saveGoodsReceiptLineQuantityScanned() {
            if (!this.scannedLine) {
                return
            }

            this.$http.post(`/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/storage-locations/${this.storageZoneIdentifier}/process-goods-receipt-line/${this.scannedLine.id}`, {
                quantity_scanned: this.quantity,
            })
                .catch(e => {
                    this.$alert(`Er is iets misgegaan bij het vastleggen van de scan op de goederenontvangstregel. Neem contact op met OmniStock.`, 'danger')
                })
        },
        closeUnableToShipView(alertMessage) {
            this.isUnableToShipMode = false
            this.unableToShipMessage = alertMessage
        },
    },

    watch: {
        isUnableToShipMode(val) {
            if (val) {
                this.$root.$emit('bv::toggle::collapse', `accordion-product-scan-unable-to-ship`)
                this.$smoothScroll({
                    scrollTo: this.$refs['product-scan'],
                    updateHistory: false,
                    offset: -5,
                })
            }
            else {
                this.$root.$emit('bv::toggle::collapse', `accordion-product-scan-main`)
                this.getProductScanSuggestion()
            }
        },
    },
}
</script>

<style scoped lang="scss">
.accordion {
    .inactive {
        opacity: 0.4;
        //display: none;
    }
}
.loader {
    font-size: 12px;
    line-height: 18px;
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #3498db;
    width: 25px;
    height: 25px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    float: left;
    margin: 0 10px 0 0;
    padding: 0 0 0 5px;
}
</style>
